import { render, staticRenderFns } from "./Comission.vue?vue&type=template&id=bb43676c&"
import script from "./Comission.vue?vue&type=script&lang=js&"
export * from "./Comission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports